import { toBePartiallyChecked } from "@testing-library/jest-dom/dist/matchers"

const facilities = [
    {
        name: 'New Year',
        primaryPic: 'leilabphoto1.jpg',
        title: 'Happy New Year!',
        Content: [  
            `Lei Lab photo of 2022.
            `,
        ]
    },
    {
        name: '2021 Fall MRS Meeting (Boston)',
        primaryPic: 'ningxin_nomination.jpg',
        title: 'Congrats to Ningxin for wining the Best Poster nomination in 2021 Fall MRS Meeting (Boston)',
        content: [
            `Congrats to Ningxin for wining the 'Best Poster' nomination in all sections! 
            `,
        ]
    },
    {
        name: '2021 Fall MRS Meeting (Boston)',
        primaryPic: 'ningxin-Boston-presentation.jpg',
        title: 'Ningxin shared her work in 2021 Fall MRS Meeting (Boston)',
        content: [
            `Ningxin gave the presentation about van der Waals semiconductor empowered vertical color sensor and communicated with peers in the poster exhibition.
            `,
        ]
    },
    {
        name: '2021 Fall MRS Meeting (Boston)',
        primaryPic: 'aisha boston award.jpg',
        title: 'Congrats to Aisha for the achievements in 2021 Fall MRS Meeting (Boston)',
        content: [
            `Congrats to Aisha for wining the "Best Poster Award" in section "Beyond Graphene 2D Materials-Synthesis, Properties and Device Applications".
            `,
        ]
    },
    {
        name: 'funding',
        primaryPic: 'oakridge.png',
        title: 'Leis lab has funding from OakRidge National Labooratory',
        content: [
            `
            `,
        ]
    },
    {
        name: 'funding',
        primaryPic: 'nsf.jpg',
        title: 'Leis lab has funding from NSF',
        content: [
            `
            `,
        ]
    },
    {
        name: 'defense',
        primaryPic: 'phd.jpg',
        title: 'Congrats to Aisha and Ningxin for passing their defense',
        content: [
            `
            `,
        ]
    },
    {
        name: 'website',
        primaryPic: 'website-launch.png',
        title: 'Newly designed website: )',
        content: [
            `
            `,
        ]
    },
    {
        name: 'teeth',
        primaryPic: 'teeth.jpg',
        title: 'Aisha got her teeth cured👏',
        content: [
            `
            `,
        ]
    },
    {
        name: 'polymerization',
        primaryPic: 'https://sites.gsu.edu/slei/files/2020/10/logo.gif',
        title: '3D printed GSU logo by our two-photon polymerization system',
        content: [
            `
            `,
        ]
    },
    {
        name: 'laser-writing',
        primaryPic: 'https://sites.gsu.edu/slei/files/2020/10/873368469848972638.jpg',
        title: 'Our direct laser writing system',
        content: [
            `
            `,
        ]
    },
    {
        name: 'holder',
        primaryPic: 'https://sites.gsu.edu/slei/files/2020/02/WeChat-Image_20200227230204-e1582862656287.jpg',
        title: 'New cryostat sample holder is ready',
        content: [
            `
            The upgrading provides us much better thermal contact and on-board temperature sensor. Thus lower temperatures can be reached with more precise control. 
            The parts were fabricated by Sam Mayberry in our Instrument Shop. 
            `,
        ]
    },
    {
        name: 'channel',
        primaryPic: 'https://sites.gsu.edu/slei/files/2020/02/a19f32bbe56d2eb9b54dcf2fc927f49.jpg',
        title: 'Narrow, but still connected channel',
        content: [
            `
            `,
        ]
    },
    {
        name: 'diy',
        primaryPic: 'https://sites.gsu.edu/slei/files/2020/02/8de848f2f971ab2959337e0281fea3a.jpg',
        title: 'DIY in the Studio',
        content: [
            `
            `,
        ]
    },
    // {
    //     name: 'synthesis',
    //     primaryPic: 'facility5.jpg',
    //     title: 'Materials Synthesis Facilities',
    //     content: [
    //         `
    //         Our Functional Material Studio is equipped with multiple material preparation and growth facilities to meet the requirement of high-quality material for our internal research and collaborations. 
    //         `,
    //     ]
    // },
    // {
    //     name: 'device',
    //     primaryPic: 'facility1.jpg',
    //     title: 'Device Fabrication Facilities',
    //     content: [
    //         `
    //         empty
    //         `,
    //     ]
    // },
    
];

export default facilities;